// extracted by mini-css-extract-plugin
export default {"headerContainer":"ProductBrowserPage_headerContainer__tFkOS","contentContainer":"ProductBrowserPage_contentContainer__ORhL3"};